export default __webpack_public_path__ + "static/media/Gilroy-Light.1b7fff53.ttf";